import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { DataLayerState } from './data-layer.state';
import { DataLayer } from '../../models/data-layer';
import { StateFilter } from '../crud.state';
import { makeUniqueNumberArray } from '../../utility/array.utility';

const filterItems = (items: DataLayer[], filter: StateFilter) => {
  return items.filter(item => {
    const publishMatch =
      filter.published === item.published || filter.published === null;

    return publishMatch;
  });
};
export function groupByType(dataLayers: DataLayer[]) {
  const grouped = dataLayers.reduce(
    (acc, layer) => {
      const { parent } = layer;
      if (!acc[parent]) acc[parent] = [];
      acc[parent].push(layer);
      return acc;
    },
    {} as Record<string, DataLayer[]>
  );

  // Sort each group
  Object.values(grouped).forEach(group =>
    group.sort((a, b) => b.year - a.year)
  );

  return grouped;
}

export function withDataLayerSelectors() {
  return signalStoreFeature(
    {
      state: type<DataLayerState>(),
    },
    withComputed(({ items, filter }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      availableYears: computed(() =>
        makeUniqueNumberArray(
          Object.values(items()).map(layer => Number(layer.year))
        )
      ),
      filteredItems: computed(() => {
        const all = items();
        let filtered = Object.values(all);
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered as DataLayer[];
      }),
      groupedByType: computed(() => {
        return groupByType(Object.values(items()));
        // const grouped = Object.values(items()).reduce(
        //   (acc, layer) => {
        //     const { parent } = layer;
        //     if (!acc[parent]) acc[parent] = [];
        //     acc[parent].push(layer);
        //     return acc;
        //   },
        //   {} as Record<string, DataLayer[]>
        // );
        //
        // // Sort each group
        // Object.values(grouped).forEach(group =>
        //   group.sort((a, b) => b.year - a.year)
        // );
        //
        // return grouped;
      }),
    }))
  );
}
